import { Document, Page, Text, View } from "@react-pdf/renderer";
import { stylePDF as sg } from "../styles";
import HeaderPDF from "../Header";
import FooterPDF from "../Footer";
import { Archivo } from "../../../../types/filemanager/Archivo";
import { fDate, getFileNameFromSrc } from "../../../../libs/formats";
import { Folder } from "../../../../types/filemanager/Folder";
import { TipoDocumento } from "../../../../types/filemanager/TipoDoc";


export default function Archivos(data: Archivo[]) {
	return (
		<Document >
			<Page style={[sg.page]} orientation="landscape">
				<HeaderPDF title="Archivos" />
					<Documentos file={data}/>
				<FooterPDF />
			</Page>
		</Document>
	);
}

function Documentos({ file }: { file: Array<any> }) {
	return (
		<View style={[{ marginTop: "15px" }]}>
			<View style={[sg.tBold, sg.fs11, sg.tCenter]}>
				<Text>Reporte de archivos</Text>
			</View>
			<View style={[{ marginTop: "8px" }]}>
				<View style={[{ marginTop: "2px" }]}>
					<View style={[sg.row, sg.bDown, sg.bTop, sg.tCenter, sg.tBold, sg.tHeader]} fixed>
						<View style={[sg.w20, sg.bEnd, sg.pCell, sg.vCenter]}>
							<Text>Nombre del archivo</Text>
						</View>
                        <View style={[sg.w15, sg.pCell, sg.bEnd, sg.vCenter]}>
							<Text>Propietario</Text>
						</View>
                        <View style={[sg.w10, sg.pCell, sg.bEnd, sg.vCenter]}>
							<Text>Tipo</Text>
						</View>
						<View style={[sg.w15, sg.pCell, sg.bEnd, sg.vCenter]}>
							<Text>Folder</Text>
						</View>
						<View style={[sg.w30, sg.pCell, sg.bEnd, sg.vCenter]}>
							<Text>Ruta</Text>
						</View>
						<View style={[sg.w10, sg.pCell, sg.vCenter]}>
							<Text>Fecha de creación</Text>
						</View>
					</View>
                    {file.map((u: Archivo , ix: number) => (
						<FilesMap file={u} key={"rp" + ix} />
					))}
				</View>
			</View>
		</View>
	);
}

function FilesMap({ file }: { file: Archivo}) {
	return (
		<View style={[sg.row, sg.bDown]}>
            <View style={[sg.w20, sg.bEnd, sg.pCell, sg.vCenterL]}>
                <Text>{getFileNameFromSrc(file.src)}</Text>
            </View>
			<View style={[sg.w15, sg.bEnd, sg.pCell, sg.vCenterL]}>
				<Text>{(file.propietary as any)?.fullname || `Sin propietario`}</Text>
			</View>
            <View style={[sg.w10, sg.bEnd, sg.pCell, sg.vCenter]}>
				<Text>{(file.tag as TipoDocumento).name}</Text>
			</View>
			<View style={[sg.w15, sg.bEnd, sg.pCell, sg.vCenterL]}>
				<Text>{(file.folder as Folder).name}</Text>
			</View>
			<View style={[sg.w30, sg.bEnd, sg.pCell, sg.vCenterL]}>
				<Text>{file.src}</Text>
			</View>
			<View style={[sg.w10, sg.pCell, sg.vCenter]}>
				<Text>{fDate(file.createdAt as string)}</Text>
			</View>
		</View>
	);
}